export default "__VITE_ASSET__376399f9__"